import { browserCheck } from '@ta-interaktiv/browsercheck'
export const config = { isMobile: browserCheck.isMobile, iconWidth: 30 }
